import {createAction} from "redux-actions";

export const requestConversationsAction = createAction('REQUEST_CONVERSATIONS_ACTION');
export const receiveConversationsAction = createAction('RECEIVE_CONVERSATIONS_ACTION');
export const clearConversationsAction = createAction('CLEAR_CONVERSATIONS_ACTION');

export const requestMessagesAction = createAction('REQUEST_MESSAGES_ACTION');
export const receiveMessagesAction = createAction('RECEIVE_MESSAGES_ACTION');
export const clearMessagesAction = createAction('CLEAR_MESSAGES_ACTION');

export const sendMessageAction = createAction('SEND_MESSAGE_ACTION');
export const composeMessageAction = createAction('COMPOSE_MESSAGE_ACTION');
export const requestFailed = createAction("REQUEST_FAILED");
export const requestStarted = createAction("REQUEST_STARTED");
export const requestSucceeded = createAction("REQUEST_SUCCEEDED");





// WEBPACK FOOTER //
// ./app/client/message/actions.ts